<template>
  <section>
    <NavAnchor
      :product-name="$t('common.productName.vidar')"
      :spec-url="'/product/lawnmowerspec'"
      :product-url="'/product/lawnmower'"
    />
    <div class="content m-a">
      <div class="w1000px m-a">
        <h6 class="ta-c">QUICK SPECS</h6>
        <table>
          <tr>
            <td>Dimension (L * W * H)</td>
            <td>
              <div>5.36 * 4.28 * 7.46 (ft)</div>
              <div>1635 * 1305 * 2273 (mm)</div>
            </td>
          </tr>
          <tr>
            <td>Weight</td>
            <td>738 lb ± 22 lb (335 ± 10 kg)</td>
          </tr>
          <tr>
            <td>Deck Cutting Width</td>
            <td>42'' (1067 mm)</td>
          </tr>
          <tr>
            <td>Number of Blades</td>
            <td>2</td>
          </tr>
          <tr>
            <td>Cutting Height</td>
            <td>1.2''–5.0'' (30–127 mm)</td>
          </tr>
          <tr>
            <td>Working Area ( Per Full Charge )</td>
            <td>6 acres (24,281 ㎡)</td>
          </tr>
          <tr>
            <td>Battery Capacity</td>
            <td>6.79 kWh</td>
          </tr>
          <tr>
            <td>Ground Speed</td>
            <td>7.46 mph (12 km/h) max</td>
          </tr>
          <tr>
            <td>Ground Capability</td>
            <td>Gradeability:20° ; Parking:16.7°</td>
          </tr>
          <tr>
            <td>Max Distance of Remote Control</td>
            <td>2,624 ft (800 m)</td>
          </tr>
          <tr>
            <td>Operation Modes</td>
            <td>Manual , Remote Control , Autonomous</td>
          </tr>
          <tr>
            <td>RTK Frequency</td>
            <td>
              <div>GPS L1/L2 ; BDS B1/B2/B3 ;</div>
              <div>Galileo E1/E2/E5a/E5b ; Glonass L1/L2</div>
            </td>
          </tr>
          <tr>
            <td>Certifications</td>
            <td>CE/FCC/SGS-NorthAmerica</td>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
  import NavAnchor from '@/components/NavAnchor'

  export default {
    components: {
      NavAnchor
    },
    head() {
      return {
        title: 'FJD Vidar',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Lawnmower, auto mower, Zero-Turn,100% Electric Control, FJDynamics, FJD '
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'Redefine your mowing experience with GNSS positioning and robotics technology. To explore how FJDynamics makes a perfect cut'
          }
        ]
      }
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .wrap {
    margin-top: 0.76rem;
  }
  .w1000px {
    width: 10rem;
  }
  .content {
    color: #000;
    padding-top: 1.36rem;
  }
  .content h6 {
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 32px;
  }
  .content table {
    width: 100%;
    margin-bottom: 75px;
  }
  .content tr:nth-child(odd) {
    background-color: #f8f9fb;
  }
  .content td {
    position: relative;
    padding: 10px 0;
    font-size: 16px;
    color: #333;
    width: 300px;
    text-indent: 24px;
  }
  .content td:nth-child(2n + 1) {
    font-size: 16px;
    font-weight: 700;
  }
  .second-text {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 40%;
  }
  @media screen and (min-width: 768px) {
    /* nav-anchor */
    .nav-anchor {
      height: 0.56rem;
      top: 3.958vw;
      position: sticky;
      box-shadow: 0px 0.02rem 0.04rem 0px rgba(0, 0, 0, 0.1);
    }
    .nav-anchor > div {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    .nav-anchor a {
      margin-left: 0.8rem;
    }
    .nav-anchor .nav-anchor-item a:hover {
      font-weight: 700;
    }
    .nav-anchor .dealer-free-quote-btn {
      width: 1.2rem;
      line-height: 0.32rem;
      transition: background-color 0.3s linear;
    }
    .nav-anchor .dealer-free-quote-btn:hover {
      color: #fff;
      background-color: rgba(34, 34, 34, 0.85);
    }
  }
</style>
